<div class="app-shell">
  <div class="app-parallax-backdrop" aria-hidden="true">
    <div class="app-parallax-base"></div>
    <div
      class="app-parallax-layer app-parallax-layer--deep"
      [style.transform]="layerDeep()"
    ></div>
    <div
      class="app-parallax-layer app-parallax-layer--mid"
      [style.transform]="layerMid()"
    ></div>
  </div>
  <div
    class="app-stage"
    [attr.inert]="destructiveOpsSetupRequired() ? '' : null"
    [attr.aria-hidden]="destructiveOpsSetupRequired() ? 'true' : null"
  >
    @if (showSiteChrome()) {
    <app-navbar></app-navbar>
    }
    <router-outlet></router-outlet>
    @if (showSiteChrome()) {
    <app-footer></app-footer>
    }
  </div>

  @if (showSiteChrome()) {
  <!-- Skip hydration: Safari + event replay can leave this overlay's clicks dead. -->
  <app-cookie-consent ngSkipHydration></app-cookie-consent>
  }

  @if (destructiveOpsSetupRequired()) {
  <div class="destructive-ops-setup-backdrop" aria-hidden="true"></div>
  <section
    class="destructive-ops-setup-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="destructive-ops-setup-title"
  >
    <div class="destructive-ops-setup-card">
      <p class="destructive-ops-setup-eyebrow">Security Step-Up Required</p>
      <h2 id="destructive-ops-setup-title">
        Create your destructive operations password
      </h2>
      <p>
        Your account can perform protected operations, so it needs a separate
        operations password before you continue.
      </p>

      <form
        [formGroup]="destructiveOpsSetupForm"
        (ngSubmit)="submitDestructiveOpsSetup()"
        class="destructive-ops-setup-form"
      >
        <label>
          <span>Operations password</span>
          <input
            type="password"
            formControlName="operationsPassword"
            autocomplete="new-password"
            placeholder="At least 8 characters"
          />
          @if (destructiveOpsSetupForm.controls.operationsPassword.invalid &&
          destructiveOpsSetupForm.controls.operationsPassword.touched) {
          <small>Password must be at least 8 characters.</small>
          }
        </label>

        <label>
          <span>Confirm operations password</span>
          <input
            type="password"
            formControlName="confirmOperationsPassword"
            autocomplete="new-password"
            placeholder="Re-enter the password"
          />
          @if (destructiveOpsSetupForm.controls.confirmOperationsPassword.invalid &&
          destructiveOpsSetupForm.controls.confirmOperationsPassword.touched) {
          <small>Please confirm the operations password.</small>
          }
        </label>

        @if (destructiveOpsSetupError()) {
        <div class="destructive-ops-setup-alert">
          {{ destructiveOpsSetupError() }}
        </div>
        }

        <button
          type="submit"
          class="destructive-ops-setup-action"
          [disabled]="destructiveOpsSetupSubmitting()"
        >
          {{
            destructiveOpsSetupSubmitting()
              ? 'Creating...'
              : 'Create Operations Password'
          }}
        </button>
      </form>
    </div>
  </section>
  }
</div>
